import { render, staticRenderFns } from "./MedUserThanks.vue?vue&type=template&id=3476a721&scoped=true&"
import script from "./MedUserThanks.vue?vue&type=script&lang=js&"
export * from "./MedUserThanks.vue?vue&type=script&lang=js&"
import style0 from "./MedUserThanks.vue?vue&type=style&index=0&id=3476a721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476a721",
  null
  
)

export default component.exports